import { action } from 'typesafe-actions'

import { Id, RequestConferenceStatus } from 'src/types'

import { ConferencesActionTypes, ResponseDataConferences } from './types'

interface Options {
  page: number
  request_ids?: string[]
  filterStatus?: string[]
}

interface CheckedReceipts {
  check_receipt: boolean
  request_ticket_id: number
}

export interface SetConferenceStatusProps {
  checked_receipts?: CheckedReceipts[]
  justification?: string
  request_conference_ids: Id[]
  request_id: Id
  status: RequestConferenceStatus
}

export const getConferences = (
  options: Options = { page: 1, request_ids: [], filterStatus: [] }
) => action(ConferencesActionTypes.GET_CONFERENCES, { options })

export const getConferencesSuccess = ({
  requests: list,
  total_results
}: ResponseDataConferences) =>
  action(ConferencesActionTypes.GET_CONFERENCES_SUCCESS, {
    list,
    total_results
  })

export const getConferencesFailure = (message: string) =>
  action(ConferencesActionTypes.GET_CONFERENCES_FAILURE, { message })

export const setConferenceStatus = ({
  checked_receipts,
  justification,
  request_conference_ids,
  request_id,
  status
}: SetConferenceStatusProps) =>
  action(ConferencesActionTypes.SET_CONFERENCE_STATUS, {
    justification,
    checked_receipts,
    request_conference_ids,
    request_id,
    status
  })

export const setConferenceStatusSuccess = (message: string) =>
  action(ConferencesActionTypes.SET_CONFERENCE_STATUS_SUCCESS, { message })

export const setConferenceStatusFailure = (message: string) =>
  action(ConferencesActionTypes.SET_CONFERENCE_STATUS_FAILURE, { message })
